import { VERCEL_ENV } from "./vercelEnv";

export const getApiEndpoint = (): string => {
  return VERCEL_ENV === "preview"
    ? "/api/graphql"
    : (process.env.GRAPHQL_API as string);
};

export const getRedirectUrl = (): string => {
  return process.env.REDIRECT_URL as string;
};
